/**
 * Appends '/dash' to a URL for affiliate link tracking purposes.
 * Handles URLs with and without trailing slashes.
 * 
 * @param {string|null|undefined} url - The URL to modify
 * @returns {string|null|undefined} - The URL with '/dash' appended, or the original value if null/undefined
 * 
 * @example
 * appendDashToUrl('https://example.com/') // 'https://example.com/dash'
 * appendDashToUrl('https://example.com') // 'https://example.com/dash'
 * appendDashToUrl('https://example.com/dash') // 'https://example.com/dash' (idempotent)
 */
export function appendDashToUrl(url) {
    // Return early if url is null, undefined, or empty
    if (!url) {
        return url;
    }

    // Remove trailing slash if present
    const cleanUrl = url.replace(/\/$/, '');

    // Check if /dash already exists to prevent duplication
    if (cleanUrl.endsWith('/dash')) {
        return url;
    }

    // Append /dash to the cleaned URL
    return `${cleanUrl}/dash`;
}

/**
 * Appends '/mnc' to a URL for affiliate link tracking purposes.
 * Handles URLs with and without trailing slashes.
 * 
 * @param {string|null|undefined} url - The URL to modify
 * @returns {string|null|undefined} - The URL with '/mnc' appended, or the original value if null/undefined
 * 
 * @example
 * appendMncToUrl('https://example.com/') // 'https://example.com/mnc'
 * appendMncToUrl('https://example.com') // 'https://example.com/mnc'
 * appendMncToUrl('https://example.com/mnc') // 'https://example.com/mnc' (idempotent)
 */
export function appendMncToUrl(url) {
    // Return early if url is null, undefined, or empty
    if (!url) {
        return url;
    }

    // Remove trailing slash if present
    const cleanUrl = url.replace(/\/$/, '');

    // Check if /mnc already exists to prevent duplication
    if (cleanUrl.endsWith('/mnc')) {
        return url;
    }

    // Append /mnc to the cleaned URL
    return `${cleanUrl}/mnc`;
}
